import { Status } from "../../models/Status";

export const PRIVACY_STATUS = "PRIVACY_STATUS";

export type IState = {
  status: Status;
};
